"use strict";

var _taggedTemplateLiteral = require("/Users/sammarks/Code/website/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

require("core-js/modules/es6.object.define-property");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  input[type=\"color\" i]::-webkit-color-swatch {\n    border-width: 0;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Reset = void 0;

var styled_components_1 = require("styled-components");

exports.Reset = (0, styled_components_1.createGlobalStyle)(_templateObject());